import { useEffect, useState } from "react";
import { FileText, Download, Loader2, AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const fmtSize = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
const noSelect = { userSelect: "none", WebkitUserSelect: "none" };

function TextPreview({ blob }) {
  const [text, setText] = useState("");
  useEffect(() => { blob?.slice(0, 4000).text().then(setText).catch(() => {}); }, [blob]);
  return <pre className="mt-2 max-h-40 w-full overflow-auto whitespace-pre-wrap break-words rounded-xl p-2 text-xs" style={{ background: "rgba(0,0,0,.06)", ...noSelect }} data-testid="chat-att-text-preview">{text}</pre>;
}

export function useObjectUrl(blob) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!blob) { setUrl(""); return undefined; }
    const u = URL.createObjectURL(blob);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [blob]);
  return url;
}

export function AttachmentView({ msg, onOpen }) {
  const [full, setFull] = useState(false);
  const url = useObjectUrl(msg.blob);
  const isImage = (msg.att?.mime || "").startsWith("image/");
  if (msg.attError) return <div className="flex items-center gap-2 text-xs" data-testid={`chat-att-error-${msg.id}`}><AlertTriangle size={14} /> {msg.attError}</div>;
  if (!msg.blob) return <div className="flex items-center gap-2 text-xs" data-testid={`chat-att-loading-${msg.id}`}><Loader2 size={14} className="animate-spin" /> {msg.mine && msg.status === "sending" ? "Cifrando e enviando…" : "Baixando e decifrando…"} {msg.att?.name}</div>;
  if (isImage) {
    if (!url) return null;
    return (
      <>
        <button onClick={() => (onOpen ? onOpen() : setFull(true))} className="block overflow-hidden rounded-xl" style={noSelect} data-testid={`chat-att-image-${msg.id}`}>
          <img src={url} alt={msg.att.name} className="max-h-64 w-full object-cover" draggable={false} onContextMenu={(e) => e.preventDefault()} />
        </button>
        <Dialog open={full} onOpenChange={setFull}>
          <DialogContent className="w-[calc(100vw-1rem)] max-w-lg rounded-3xl p-3" onContextMenu={(e) => e.preventDefault()} data-testid="chat-att-fullscreen">
            <DialogTitle className="text-sm">{msg.att.name}</DialogTitle>
            <DialogDescription className="sr-only">Imagem cifrada de ponta a ponta</DialogDescription>
            <img src={url} alt={msg.att.name} className="max-h-[70vh] w-full rounded-2xl object-contain" style={noSelect} draggable={false} />
            {!msg.once && <a href={url} download={msg.att.name} className="ga-btn-ghost w-full justify-center text-sm" data-testid="chat-att-download"><Download size={14} /> Salvar</a>}
          </DialogContent>
        </Dialog>
      </>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`chat-att-file-${msg.id}`}>
      <FileText size={22} />
      <div className="min-w-0 flex-1"><div className="truncate text-sm font-medium">{msg.att.name}</div><div className="text-[11px] opacity-70">{fmtSize(msg.att.size)}{msg.once ? " · sem download" : ""}</div></div>
      {!msg.once && <a href={url} download={msg.att.name} className="flex h-9 w-9 items-center justify-center rounded-full" style={{ background: "rgba(0,0,0,.08)" }} aria-label="Baixar" data-testid={`chat-att-download-${msg.id}`}><Download size={16} /></a>}
      {msg.once && (msg.att.mime || "").startsWith("text/") && <TextPreview blob={msg.blob} />}
    </div>
  );
}
